export default function (/**@type {ApisauceInstance} */ api) {
  ///main group props
  const getAllGroups = (paging) => api.get("/group/search", paging);

  const getGroupWithId = (id) => api.get("/group/find/" + id);

  const createGroup = (payload) => api.post("/group/create", payload);

  const updateGroup = ({ payload, id }) => api.put(`group/${id}`, payload);

  const deleteGroup = (id) => api.delete("/group/remove/" + id);

  /// group clients
  const getGroupClients = (id) => api.get("/group/clients/", id);
  const createGroupClient = (payload) => api.post("/group/add-client", payload);
  const createGroupClients = (payload) =>
    api.post("/group/add-clients", payload);
  /// group outlets
  const getNonGroupedOutlets = (paging) =>
    api.get("/group/non-gouped-outlets", paging);
  const createGroupOutlet = (payload) => api.post("/group/add-outlet", payload);

  const createGroupOutlets = (payload) =>
    api.post("/group/add-outlets", payload);

  const removeGroupOutlet = (payload) =>
    api.post("/group/remove-outlet", payload);
  const removeGroupOutlets = (payload) =>
    api.post("/group/remove-outlets", payload);

  const getGroupOutletsList = (payload) =>
    api.get("/group/group-outlets", payload);

  const uploadGroupOutlets = (payload) =>
    api.post("/group/upload-outlets", payload);

  // Promoters
  const getGroupPromotersList = (payload) =>
    api.get("/Group/group-promoters", payload);

  const getNonGroupedPromoters = (paging) =>
    api.get("/Group/non-gouped-promoters", paging);

  const uploadGroupPromoters = (payload) =>
    api.post("/Group/upload-promoters", payload);

  const createGroupPromoters = (payload) =>
    api.post("/Group/add-promoters", payload);

  const removeGroupPromoters = (payload) =>
    api.post("/Group/remove-promoters", payload);

  const createGroupPromoter = (payload) =>
    api.post("/Group/add-promoter", payload);

  const removeGroupPromoter = (payload) =>
    api.post("/Group/remove-promoter", payload);

  return {
    group: {
      getAllGroups,
      getGroupWithId,
      createGroup,
      updateGroup,
      deleteGroup,
      getGroupClients,
      getNonGroupedOutlets,
      createGroupClient,
      createGroupClients,
      createGroupOutlet,
      createGroupOutlets,
      removeGroupOutlet,
      getGroupOutletsList,
      uploadGroupOutlets,
      removeGroupOutlets,

      // Promoters
      getGroupPromotersList,
      getNonGroupedPromoters,
      uploadGroupPromoters,
      createGroupPromoters,
      removeGroupPromoters,
      createGroupPromoter,
      removeGroupPromoter,
    },
  };
}
